export default __webpack_public_path__ + "static/media/betty-storyboard.9fbc6be0.png";